import { isMobile } from "react-device-detect";
import { useContext } from "react";
import { CartContext } from "./../../../../contexts/cartContext";
import "./miniToyCard.scss";
import { getBasePath } from "./../../../../helpers";

function MiniToyCard({ cartItem, handleAdd, handleRemove, handleRemoveToy }) {
  const { addCartItem, removeCartItem, decreaseCartItemQuantity } =
    useContext(CartContext);

  return (
    <div
      className="row py-3 minitoycard"
      style={
        { borderTop: "1px solid rgba(0,0,0,.1)" }
        // toy.id > 1
        //   ? { borderTop: "1px solid rgba(0,0,0,.1)" }
        //   : { borderTop: "0" }
      }
    >
      <div className="col-3 d-flex flex-column align-items-center img-quantity">
        <img
          src={`${getBasePath()}/${cartItem.toy.cover_image.image}`}
          className="img-fluid"
          alt="Imagem de Teste"
        />
        <div
          className={`d-flex align-items-center mt-1 quantity ${
            isMobile ? "flex-column gap-1" : ""
          }`}
        >
          <button
            className={`bg-danger ${cartItem.quantity > 1 ? "" : "disabled"}`}
            disabled={cartItem.quantity > 1 ? false : true}
            onClick={() => decreaseCartItemQuantity(cartItem.toy.id)}
          >
            -
          </button>
          <h1 className="mx-2">{cartItem.quantity}</h1>
          <button onClick={() => addCartItem(cartItem.toy)}>+</button>
        </div>
      </div>
      <div className="col-6 d-flex flex-column align-items-start justify-content-between labels">
        <h1>{cartItem.toy.name}</h1>
        <h4>
          <strong>Período: </strong>
          {cartItem.toy.selectedRental.period} dias
        </h4>
      </div>
      <div className="col-3 d-flex flex-column align-items-end justify-content-between price-remove">
        <h1 className="text-center">R$ {cartItem.toy.selectedRental.value}</h1>
        <button
          onClick={() => removeCartItem(cartItem.toy)}
          className="d-flex remove"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            className="bi bi-trash3"
            viewBox="0 0 16 16"
          >
            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
          </svg>
          remover
        </button>
      </div>
    </div>
  );
}

export default MiniToyCard;
